import { Link } from 'react-router';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import {
  IngredientsSlider,
  type SliderCardsContent,
} from 'Components/IngredientsSlider/IngredientsSlider';

import { ingredientsContent } from 'assets/content/homeV2';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { IngredientsTitle } from './IngredientsTitle';

const TextContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: ${theme.spacing['8x']};
`;

const IngredientsLinkContainer = styled.div`
  align-self: center;
  padding: ${theme.spacing['6x']} ${theme.spacing['4x']};
  ${legacyTheme.breakpoints.up('sm')} {
    align-self: flex-start;
  }
`;

const IngredientsLink = styled(Link)`
  /* @todo: color sorbet not in recent theme */
  border-bottom: 1px solid ${theme.colors.accent[200]};

  font-family: ${theme.typography.fontFamily.label};
  /* @todo: 13px in mockup, chosen token : 12px */
  font-size: ${theme.typography.fontSize.xs};
  font-weight: ${theme.typography.fontWeight.medium};
  /* @todo: color not in theme */
  color: ${theme.colors.primary[400]};
  text-decoration: inherit;
  text-transform: uppercase;

  &:hover {
    border-bottom: 1px solid transparent;
  }
`;

type IngredientsSectionProps = {
  trackOnChange?: () => void;
  content?: {
    titleBlock: {
      title: string;
      subtitle: string;
    };
    cta?: {
      label: string;
      path: string;
    };
    sliderCardsContent: SliderCardsContent;
  };
};

export const IngredientsSection = ({
  content = ingredientsContent,
  trackOnChange,
}: IngredientsSectionProps) => {
  const { cta } = content;
  const { isMobile } = useResponsiveVariant();
  return (
    <>
      <TextContainer>
        <IngredientsTitle subtitle={content.titleBlock.subtitle} title={content.titleBlock.title} />
        {!isMobile && cta && (
          <IngredientsLinkContainer>
            <IngredientsLink to={cta.path}>{cta.label}</IngredientsLink>
          </IngredientsLinkContainer>
        )}
      </TextContainer>
      <IngredientsSlider cardsContent={content.sliderCardsContent} trackOnChange={trackOnChange} />
      {isMobile && cta && (
        <IngredientsLinkContainer>
          <IngredientsLink to={cta.path}>{cta.label}</IngredientsLink>
        </IngredientsLinkContainer>
      )}
    </>
  );
};
